"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchainId = exports.ECHAIN_UUID_NAMESPACE = void 0;
const uuid_1 = require("uuid");
exports.ECHAIN_UUID_NAMESPACE = 'ec4a1114-dcab-43eb-bbff-99aee39a2b0e';
class EchainId {
    static fromString(input) {
        if (input === undefined)
            return undefined;
        if (!input)
            throw new Error(`${EchainId.name}.fromString(): invalid input!`);
        return this.generate(input);
    }
    static fromNumber(input) {
        if (input === undefined)
            return undefined;
        if (!input)
            throw new Error(`${EchainId.name}.fromNumber(): invalid input!`);
        return this.generate(input.toString());
    }
    static fromArtNr(artNr) {
        if (!artNr)
            return undefined;
        const determinedArtNr = artNr.DE || artNr.US;
        if (!determinedArtNr)
            throw new Error(`${EchainId.name}.fromArtNr(): invalid artNr!`);
        return this.generate(determinedArtNr);
    }
    static generate(input) {
        return (0, uuid_1.v5)(input, exports.ECHAIN_UUID_NAMESPACE);
    }
}
exports.EchainId = EchainId;
//# sourceMappingURL=EchainId.js.map